export const trapFocusInModal = (selector: string) => {
  const modal: HTMLElement | null = document.querySelector(selector);
  const focusableElements: NodeListOf<HTMLElement> | undefined = modal?.querySelectorAll(
    'input[type="radio"]:not([disabled]), button:not([disabled]), a[href]:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
  );

  const firstFocusableElement = focusableElements && focusableElements[0];
  const lastFocusableElement = focusableElements && focusableElements[focusableElements.length - 1];
  lastFocusableElement?.focus();

  modal?.addEventListener('keydown', function (event: KeyboardEvent) {
    const isTabPressed = event.key === 'Tab';
    if (!isTabPressed) return;

    if (event.shiftKey) {
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement?.focus();
        event.preventDefault();
      }
    } else if (document.activeElement === lastFocusableElement) {
      firstFocusableElement?.focus();
      event.preventDefault();
    }
  });
};
